(() => {
  if (customElements.get('nisplay-country-search')) return;

  const getCountries = () => {
    if (window.nisplayCountryData) return window.nisplayCountryData;

    const dataElement = document.getElementById('NisplayCountryData');
    if (!dataElement) return [];

    try {
      window.nisplayCountryData = JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('Unable to load country data.', error);
      window.nisplayCountryData = [];
    }

    return window.nisplayCountryData;
  };

  customElements.define('nisplay-country-search', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('input[type="search"]');
      this.list = this.querySelector('ul');
      this.status = this.querySelector('[data-country-status]');
      this.toggle = this.closest('popout-select')?.querySelector('[data-popout-toggle]');
      this.items = [];

      if (!this.input || !this.list || !this.toggle) return;

      this.handleToggle = () => {
        this.buildCountries();
        this.input.value = '';
        this.filterCountries();
      };
      this.handleInput = () => this.filterCountries();
      this.handleKeydown = event => {
        if (event.key === 'Enter') event.preventDefault();
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.items.find(item => !item.hidden)?.querySelector('a')?.focus();
        }
      };
      this.handleCountryClick = event => {
        const option = event.target.closest('[data-popout-option]');
        if (!option || !this.contains(option)) return;

        event.preventDefault();
        const popout = this.closest('popout-select');
        const countryInput = popout?.querySelector('[data-popout-input]');
        const form = popout?.closest('form');
        if (!countryInput || !form) return;

        countryInput.value = option.dataset.value;
        form.submit();
      };

      this.toggle.addEventListener('click', this.handleToggle, true);
      this.input.addEventListener('input', this.handleInput);
      this.input.addEventListener('keydown', this.handleKeydown);
      this.list.addEventListener('click', this.handleCountryClick);
      this.querySelector('[data-country-search-tools]').hidden = false;
    }

    disconnectedCallback() {
      this.toggle?.removeEventListener('click', this.handleToggle, true);
      this.input?.removeEventListener('input', this.handleInput);
      this.input?.removeEventListener('keydown', this.handleKeydown);
      this.list?.removeEventListener('click', this.handleCountryClick);
    }

    buildCountries() {
      if (this.built) return;

      const featured = (this.dataset.featured || '')
        .toUpperCase()
        .split(',')
        .map(code => code.trim())
        .filter(Boolean);
      const current = this.dataset.current;
      const showFlags = this.dataset.showFlags === 'true';
      const rank = country => {
        const index = featured.indexOf(country[0]);
        return index < 0 ? Infinity : index;
      };
      const countries = getCountries().slice().sort((a, b) => {
        return rank(a) - rank(b) || a[1].localeCompare(b[1]);
      });
      const fragment = document.createDocumentFragment();

      countries.forEach(([isoCode, name, currency, flagUrl]) => {
        const item = document.createElement('li');
        const option = document.createElement('a');
        const label = document.createElement('span');

        item.className = 'select-popout__item';
        if (isoCode === current) item.classList.add('select-popout__item--current');

        option.className = 'select-popout__option';
        option.href = '#';
        option.dataset.value = isoCode;
        option.setAttribute('data-popout-option', '');
        if (isoCode === current) option.setAttribute('aria-current', 'true');

        if (showFlags) {
          const flag = document.createElement('img');
          flag.className = 'select-popout__flag';
          flag.width = 40;
          flag.height = 30;
          flag.loading = 'lazy';
          flag.alt = '';
          flag.src = flagUrl;
          option.append(flag);
        }

        label.textContent = `${name} (${currency})`;
        option.append(label);
        item.append(option);
        fragment.append(item);
      });

      this.list.append(fragment);
      this.items = Array.from(this.list.children);
      this.built = true;
    }

    filterCountries() {
      if (!this.built) return;

      const normalize = value => value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
      const query = normalize(this.input.value);
      let count = 0;

      this.items.forEach(item => {
        const option = item.querySelector('[data-popout-option]');
        const isoCode = option.dataset.value;
        const aliases = isoCode === 'GB'
          ? 'uk united kingdom britain'
          : isoCode === 'US'
            ? 'usa united states america'
            : '';
        item.hidden = !normalize(`${item.textContent} ${isoCode} ${aliases}`).includes(query);
        if (!item.hidden) count += 1;
      });

      if (this.status) this.status.hidden = count > 0;
      this.list.scrollTop = 0;
    }
  });
})();
